export default __webpack_public_path__ + "static/media/Bắc Á Bank.13c2c471.png";